mutation Inertia_ResetMemberMfa($memberId: ID!) {
  resetMfa(input: { memberId: $memberId }) {
    member {
      id
    }
    errors
  }
}